import { useTranslation } from "react-i18next";

import { useClientData } from "../../../../../store/client/client.selectors";

export const useTranslateData = () => {
  const { t } = useTranslation();
  const { anonymityInfo } = useClientData();
  return [
    {
      title: t("global.browser"),
      description: t("scannerFingerprint.cardDescription.first"),
      status: true,
      icon: "browser",
    },
    {
      title: t("global.location"),
      description: t("scannerFingerprint.cardDescription.second"),
      status: false,
      icon: "location",
    },
    {
      title: t("global.ipAddress"),
      description: `${t("scannerFingerprint.cardDescription.third")} ${anonymityInfo?.ip}`,
      status: true,
      icon: "ipAddress",
    },
    {
      title: t("global.hardware"),
      description: t("scannerFingerprint.cardDescription.forth"),
      status: true,
      icon: "hardware",
    },
    {
      title: t("global.software"),
      description: t("scannerFingerprint.cardDescription.fifth"),
      status: true,
      icon: "software",
    },
  ];
};
